import React from "react";

interface PageHeaderProps {
  title: string;
  description: string;
  /** Conteúdo à direita da linha do título (ex.: botões de exportação). */
  actions?: React.ReactNode;
  compact?: boolean;
}

const PageHeader = ({
  title,
  description,
  actions,
  compact = false,
}: PageHeaderProps) => {
  return (
    <div className={compact ? "py-1 sm:px-0" : "py-4 sm:px-0"}>
      <div
        className={`${compact ? "mb-1.5" : "mb-2"} flex flex-col gap-3 ${
          actions
            ? "sm:flex-row sm:items-center sm:justify-between sm:gap-4"
            : ""
        }`}
      >
        <h2
          className={`font-bold text-primary ${
            compact
              ? "text-lg leading-tight sm:text-xl lg:text-2xl"
              : "text-xl sm:text-2xl lg:text-4xl"
          } ${actions ? "min-w-0 shrink" : ""}`}
        >
          {title}
        </h2>
        {actions ? (
          <div className="flex w-full shrink-0 flex-wrap items-center gap-2 sm:w-auto sm:justify-end">
            {actions}
          </div>
        ) : null}
      </div>
      {description ? (
        <p
          className={`text-start text-neutral-600 ${
            compact ? "text-sm sm:text-base" : "text-sm sm:text-base lg:text-lg"
          }`}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
};

export default PageHeader;
